/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarBlurbs_user = {
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSidebarBlurbShipping_user">;
    readonly " $refType": "PdpRespSidebarBlurbs_user";
};
export type PdpRespSidebarBlurbs_user$data = PdpRespSidebarBlurbs_user;
export type PdpRespSidebarBlurbs_user$key = {
    readonly " $data"?: PdpRespSidebarBlurbs_user$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSidebarBlurbs_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespSidebarBlurbs_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarBlurbShipping_user",
      "args": null
    }
  ]
};
(node as any).hash = 'fc8f4160db78d54849d81f834bb5e596';
export default node;
